import React, { useState, useContext } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { logActivity } from "../../utils/LogActivity";
import { AuthContext } from "../../Context/AuthContext";

const EditCircleForm = ({ circle, onClose }) => {
  const Api = process.env.REACT_APP_API;
  const [circleName, setCircleName] = useState(circle.circleName);
  const [circleCode, setCircleCode] = useState(circle.circleCode);
  const { userId } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = { circleName, circleCode };

    try {
      const authData = localStorage.getItem("authData");
      let config = "";

      if (authData) {
        const parsedData = JSON.parse(authData); // Parse the string into an object

        // Extract the token from the parsed data
        const token = parsedData.userToken; // Assuming the token is stored in the 'token' field
        const permissionToken = parsedData.token;
        // Set up the axios config with Authorization header
        config = {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            // "X-Permission-Token": permissionToken,
          },
        };
      }
      const response = await fetch(`${Api}/api/circles/${circle._id}`, config, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Submitted Successfully");

        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    await logActivity(
      userId,
      "Edited Excisting Circle",
      "Edited Circle Page",
      Api
    );
  };
  return (
    <div>
      <Modal show onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Edit Circle</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formStateName">
              <Form.Label>
                Circle Name<span className="required-asterisk">*</span>
              </Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  name="circleName"
                  value={circleName}
                  onChange={(e) => setCircleName(e.target.value)}
                  required
                />
              </div>
            </Form.Group>

            <Form.Group controlId="form Circle Code">
              <Form.Label>
                Circle Code<span className="required-asterisk">*</span>
              </Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  name="circleCode"
                  value={circleCode}
                  onChange={(e) => setCircleCode(e.target.value)}
                  required
                />
              </div>
            </Form.Group>
            <button
              type="submit"
              className="btn btn-outline-success btn-icon-text mt-3"
            >
              Edit
              <i className="mdi mdi-file-check btn-icon-append"></i>
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditCircleForm;
